import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { CONTACT } from "../data/siteContent";
import { EASE } from "./shared";

const WhatsAppIcon = ({ size = 26 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413" />
    </svg>
);

const waLink = (phone) => {
    const number = phone.replace(/[^0-9]/g, "");
    const text = encodeURIComponent(
        "Hello First Choice Trading Company, I have an enquiry about your machined parts."
    );
    return `https://wa.me/${number}?text=${text}`;
};

const WhatsAppButton = () => {
    const [open, setOpen] = useState(false);

    return (
        <div className="fixed bottom-6 left-6 z-[60] flex flex-col items-start gap-3">
            <AnimatePresence>
                {open && (
                    <motion.div
                        data-testid="whatsapp-panel"
                        initial={{ opacity: 0, y: 16, scale: 0.96 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 16, scale: 0.96 }}
                        transition={{ duration: 0.3, ease: EASE }}
                        className="bg-[#F0F0F0] border border-[#D9D9D9] shadow-2xl w-72"
                    >
                        <div className="px-5 py-4 border-b border-[#D9D9D9]">
                            <span className="block text-[11px] uppercase tracking-[0.25em] text-copper">
                                Chat on WhatsApp
                            </span>
                            <span className="block text-sm text-[#595959] mt-1">
                                We usually reply within business hours.
                            </span>
                        </div>
                        <a
                            data-testid="whatsapp-chat-link-0"
                            href={waLink(CONTACT.whatsapp)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group flex items-center gap-3 px-5 py-4 hover:bg-[#EBEBEB] transition-colors duration-300"
                        >
                            <span className="text-[#25D366]">
                                <WhatsAppIcon size={20} />
                            </span>
                            <span>
                                <span className="block text-sm text-[#111111] group-hover:text-[#25D366] transition-colors duration-300">
                                    {CONTACT.whatsapp}
                                </span>
                                <span className="block text-[11px] text-[#737373] uppercase tracking-[0.15em]">
                                    Sales, Quotes & Orders
                                </span>
                            </span>
                        </a>
                    </motion.div>
                )}
            </AnimatePresence>

            <motion.button
                data-testid="whatsapp-fab"
                onClick={() => setOpen((v) => !v)}
                aria-label={open ? "Close WhatsApp chat" : "Chat on WhatsApp"}
                whileHover={{ scale: 1.06 }}
                whileTap={{ scale: 0.94 }}
                className="w-14 h-14 rounded-full bg-[#25D366] text-[#FAFAFA] flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.35)]"
            >
                {open ? <X size={24} /> : <WhatsAppIcon />}
            </motion.button>
        </div>
    );
};

export default WhatsAppButton;
